/**
 * Purpose: Determine who may edit a society hub (owner, Django staff/superuser, platform admin role).
 * Inputs: current user object (from AuthContext), society object from API (must include `user` id).
 * Outputs: boolean
 */
export function canManageSociety(user, society) {
  if (!user || !society) return false;
  const ownerId = society.user != null ? Number(society.user) : NaN;
  const uid = user.id != null ? Number(user.id) : NaN;
  if (Number.isFinite(ownerId) && Number.isFinite(uid) && ownerId === uid) return true;
  if (user.is_superuser) return true;
  if (user.is_staff) return true;
  if (user.role === 'admin') return true;
  return false;
}
